import {ClientInsuranceService} from 'services/clientInsuranceService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {ClientInsurance} from 'types/clientInsurance';

const clientInsuranceFactory = (data: any) => new ClientInsurance(data);

export const ClientInsuranceThunks = createEntityThunks<ClientInsurance>(
  'clientInsurance',
  ClientInsuranceService,
  {activate: true, deactivate: true},
  clientInsuranceFactory,
);
